// extracted by mini-css-extract-plugin
export var aircallIframe = "_jw-3";
export var fabContainer = "_jw-5";
export var fabRinging = "_jw-6";
export var loadingOverlay = "_jw-4";
export var pulse = "_jw-7";
export var widgetContent = "_jw-2";
export var widgetPanel = "_jw-0";
export var widgetPanelExpanded = "_jw-1";